import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useNavContext } from "../context/nav_context";
import { useMatchContext } from "../context/match_context";
import { Flag, MatchDetailManage, MatchDetailSpectator } from "../components";

const MatchDetail = ({ matchId }) => {
  const { user } = useNavContext();
  const [seasonName, setSeasonName] = useState();
  const [divisionName, setDivisionName] = useState();
  const { fetchMatch, loading, error, match } = useMatchContext();
  const [isPlayer, setIsPlayer] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    fetchMatch(matchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchMatch(matchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchId]);

  useEffect(() => {
    if (match) {
      setSeasonName(`Temporada ${match.seasonId}`);
      setDivisionName(`${match.divisionName} > ${match.groupName}`);
    }

    if (user && match) {
      if (user.userId === match.playerAid || user.userId === match.playerBid) {
        setIsPlayer(true);
      }

      if (user.isAdmin === 1) {
        setIsAdmin(true);
      }
    }
  }, [user, match]);

  if (loading) {
    return (
      <main>
        <Wrapper className="page section section-center">
          <div className="error">Cargando...</div>
        </Wrapper>
      </main>
    );
  }
  if (error) {
    return (
      <main>
        <Wrapper className="page section section-center">
          <div className="error">
            Error cargando la info del partido. Contacta con los
            administradores.
          </div>
        </Wrapper>
      </main>
    );
  }
  if (!match) {
    return (
      <main>
        <Wrapper className="page section section-center">
          <div className="error">Partido no encontrado</div>
        </Wrapper>
      </main>
    );
  }
  if (match && match.status === "HIDDEN") {
    return (
      <main>
        <Wrapper className="page section section-center">
          <div className="error">
            Listillo!!! Este partido todavía es secreto. En breve se anunciará
          </div>
        </Wrapper>
      </main>
    );
  }

  // ok
  const groupLink = `/season/${match.seasonId}/group/${match.groupId}`;
  return (
    <main>
      <Wrapper className="page section section-center">
        <article>
          <p className="breadcrumb">
            <span className="no-mobile">
              Liga Española <span className="separator">&gt;</span>{" "}
            </span>
            <span>{seasonName}</span> <span className="separator">&gt;</span>
            <span>
              <Link to={groupLink}>{divisionName}</Link>
            </span>
            <span className="separator">&gt;</span>
            <span>
              {match.playerAusername} vs {match.playerBusername}
            </span>
          </p>

          <div className="row-2">
            <div className="flag">
              <Flag
                playerName={match.playerAusername}
                playerImg={match.playerAdiscordAvatarURL}
                playerClan=""
                haloColor="#6bb621"
                flagColor="#e4ec8b"
                playerDiscord={match.playerAdiscordUsername}
                playerAoe2netPrincipal={match.playerAaoe2ProfileId}
              />
            </div>

            <div className="row-2 no-mobile">
              {isAdmin || (isPlayer && match.status !== "REVIEWED") ? (
                <MatchDetailManage isAdmin={isAdmin} />
              ) : (
                <MatchDetailSpectator />
              )}
            </div>

            <div className="flag">
              <Flag
                playerName={match.playerBusername}
                playerImg={match.playerBdiscordAvatarURL}
                flagColor="#F7A399"
                playerDiscord={match.playerBdiscordUsername}
                playerAoe2netPrincipal={match.playerBaoe2ProfileId}
              />
            </div>
          </div>
          <div className="row-2 no-web">
            {isAdmin || (isPlayer && match.status !== "REVIEWED") ? (
              <MatchDetailManage isAdmin={isAdmin} />
            ) : (
              <MatchDetailSpectator />
            )}
          </div>
        </article>
      </Wrapper>
    </main>
  );
};

const Wrapper = styled.section`
  padding: 1rem 0;

  .breadcrumb {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5rem;

    .separator {
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }

  article {
    display: flex;
  }

  .row-2 {
    display: flex;
    justify-content: space-between;
    width: 98vw;
  }

  .flag {
    width: 25vw;
  }

  .info-match {
    width: 50vw;
  }

  .background {
    width: 100%;
    position: absolute;
    z-index: -10;
    top: var(--header-height);
    right: 0;
    opacity: 0.5;
  }

  article {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .opponents {
    font-size: 2rem;

    b {
      margin-right: 2.5rem;
      margin-left: 2.5rem;
      font-size: 2.5rem;
    }
  }

  .result {
    display: flex;
    justify-content: center;
    font-size: 4.5rem;

    div {
      font-size: 1.5rem;
      text-transform: none;
    }
  }
  .edit-icon {
    margin-left: 0.5rem;
    cursor: pointer;
  }

  @media (min-width: 800px) {
    .no-web {
      display: none !important;
    }

    .no-mobile {
      display: flex !important;
    }
  }

  @media (max-width: 800px) {
    .no-web {
      display: flex !important;
    }

    .no-mobile {
      display: none !important;
    }

    .row-2 {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    .flag {
      width: 50vw;
    }
  }
`;
export default MatchDetail;
